"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.withTheme = exports.useTheme = exports.ThemeProvider = void 0;
var react_1 = require("@emotion/react");
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return react_1.ThemeProvider; } });
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return react_1.useTheme; } });
Object.defineProperty(exports, "withTheme", { enumerable: true, get: function () { return react_1.withTheme; } });
exports.defaultTheme = {
    colors: {
        primary: '#3A23AD',
        secondary: '#00cee1',
        hover: '#f8f6fd',
        text: {
            secondary: '#ffffff',
        },
        message: {
            error: '#cc1212',
            warning: '#ecaa15',
            info: '#4c3ce2',
        },
    },
    components: {},
};
